import { useCallback } from "react";
import { getCompanyList } from "src/apis/companyApi";
import { getMenuList } from "src/apis/menuApi";
import { getMyInfo } from "src/apis/userApi";
import { MinWidthNumber } from "src/components/common/common";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useCompanyStore } from "src/store/useCompanyStore";
import useMenuStore from "src/store/useMenuStore";
import useScreenStore from "src/store/useScreenStore";
import useUiuxStore, { Tab } from "src/store/useUiuxStore";
import useUserStore from "src/store/useUserStore";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";

interface Props {
	tabList: Tab[];
	tabDivRef: React.RefObject<HTMLDivElement | null>;
}


export const Content_Home = (props: Props) => {

	const {
		tabDivRef,
	} = props;

	const { 
		tabList,
		setSidebarVisible,
	} = useUiuxStore();

	const {
		fetchBankacctCdCode,
		fetchBookmarkCdCode,
		fetchCommonCode,
		fetchCustomCdCode,
		fetchCompCdCode,
		fetchEquipmentCdCode,
		fetchEmployeeCdCode,
		fetchMenuCdCode,
		fetchOrgCdCode,
		fetchWarehouseCdCode,
		fetchWorkPlaceCdCode,
		fetchItemCdCode,
	} = useCommonCodeStore();

	const { setUserInfo, setUserInCompanyList, initData: initUserData } = useUserStore();
	const { companyList, setCompanyList, initData: initCompanyData } = useCompanyStore();
	const { loadingSpinner, setLoadingSpinner } = useLoadingSpinnerStore();
	const { setMenuList } = useMenuStore();
	
	const {
		setScreenWidth,
		setScreenHeight,
		// setCompactSettings,
		tabDivFloorHeight, setTabDivFloorHeight,
		tabDivWidth, setTabDivWidth,
		tabDivHeight, setTabDivHeight,
		tabWidth, setTabWidth,
		tabHeight, setTabHeight
	} = useScreenStore();

	
	const handleResize = () => {
		setScreenWidth(window.innerWidth);
		setScreenHeight(window.innerHeight);

		if (tabDivRef.current) {
			const currentTabDivWidth = tabDivRef.current.offsetWidth;
			// console.log(`tabDiv의 현재 너비: ${currentTabDivWidth}px`);

			//currentTabDivWidth를 바탕으로 현재 탭 1층에 몇개의 tab가 들어갈지 계산
			const floorTabMaxWidth = Math.floor(currentTabDivWidth / tabWidth) * tabWidth;
			// console.log( '현재 1층에 들어갈 tab의 공간 너비 :', floorTabMaxWidth);

			const totalTabsWidth = tabWidth * tabList.length;
			const floorNumber = Math.floor((totalTabsWidth - 1) / floorTabMaxWidth);
			// console.log( 'totalTabsWidth ' + totalTabsWidth + ' > floorTabMaxWidth ' + floorTabMaxWidth + ' > tab층 :', floorNumber);
			if (totalTabsWidth > currentTabDivWidth) {
				// alert(`탭의 전체 너비(${totalTabsWidth}px)가 탭 컨테이너의 너비(${currentTabDivWidth}px)를 초과했습니다.`);
				setTabDivHeight(tabDivFloorHeight * (floorNumber + 1) + (2 * floorNumber));
			}
		}
	};

	const refreshMesInfo = useCallback(async () => {
		setLoadingSpinner(true);
		try {
			const myInfo = (await getMyInfo())?.data?.data;
			setUserInfo(myInfo);
			const menuData = (await getMenuList()).data.data;
			setMenuList(menuData);
	
			const companyList = (await getCompanyList()).data.data;
			setCompanyList(companyList);
			if (companyList.length > 0) {
				setUserInCompanyList(companyList);
			}
	
			const sidebarVisibleString = localStorage.getItem('sidebar-visible');
			setSidebarVisible(sidebarVisibleString === 'true');
	
			await Promise.all([
				fetchBankacctCdCode(),
				fetchBookmarkCdCode(),
				fetchCommonCode(),
				fetchCustomCdCode(),
				fetchCompCdCode(),
				fetchEmployeeCdCode(),
				fetchEquipmentCdCode(),
				fetchMenuCdCode(),
				fetchOrgCdCode(),
				fetchWarehouseCdCode(),
				fetchWorkPlaceCdCode(),
				fetchItemCdCode(),
			]);
		} catch (e) {
			console.error('초기화 실패:', e);
		} finally {
			setLoadingSpinner(false);  // ★ 성공이든 실패든 무조건 꺼짐
		}
	}, []);


	return {
		handleResize,
		refreshMesInfo,
	}
};